export enum Status {
  INITIAL = 'initial',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAIL = 'fail',
}
